export default __webpack_public_path__ + "static/media/33.67fe0122.jpg";